import { Link } from 'react-router-dom';
import { SITE, FOOTER_LINKS } from '@/data/site';
import { categories } from '@/data/categories';

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-accent-950 text-background-100 mt-20">
      <div className="max-w-container mx-auto px-4 md:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-accent-950 flex items-center justify-center">
                <i className="ri-leaf-line text-xl" />
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading font-bold text-lg text-background-50">
                  {SITE.name}
                </span>
                <span className="text-[11px] tracking-[0.28em] text-accent-300 mt-0.5">
                  {SITE.subName}
                </span>
              </div>
            </div>
            <p className="mt-5 text-sm leading-7 text-background-200/80 max-w-md">
              {SITE.description}
            </p>
            <p className="mt-4 text-sm text-accent-300 italic font-heading">
              「 {SITE.slogan} 」
            </p>
          </div>

          {FOOTER_LINKS.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading font-semibold text-background-50 text-sm mb-4">
                {col.title}
              </h3>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-200/80 hover:text-accent-300 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-background-200/60">
            © {year} {SITE.name} · 内容仅供阅读与交流，请理性围观、尊重他人。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-200/60">
            <a
              href={`mailto:${SITE.email}`}
              className="hover:text-accent-300 transition-colors"
            >
              {SITE.email}
            </a>
            <span className="hidden sm:inline">|</span>
            <span>共 {categories.length} 个栏目</span>
          </div>
        </div>
      </div>
    </footer>
  );
}